import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMozila = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={21}
    height={20}
    fill='none'
    {...props}
  >
    <rect width={19} height={19} x={1.3} y={0.5} fill='url(#mozila_svg__a)' rx={9.5} />
    <defs>
      <pattern id='mozila_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#mozila_svg__b' transform='matrix(.0005 0 0 .0005 0 -.02)' />
      </pattern>
      <image
        xlinkHref='/images/icons/mozila-48f1035a.webp'
        id='mozila_svg__b'
        width={1971}
        height={2048}
      />
    </defs>
  </svg>
);
export default SvgMozila;
